// extracted by mini-css-extract-plugin
export default {"innerWrapper":"zs-z","tooltipWrapper":"As-z","icon":"Bs-z","tooltip":"Cs-z","content":"Ds-z"};